import { cn } from 'lib/utils'
import { FormError } from 'components/atoms/FormError'
import type { InputHTMLAttributes, ReactNode } from 'react'

export interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'className' | 'type'
> {
  error?: string
  className?: string
  children?: ReactNode
}

export const Checkbox = ({
  error,
  className,
  children,
  ...checkboxProps
}: CheckboxProps) => {
  return (
    <div className="checkbox">
      <label>
        <input type="checkbox" {...checkboxProps} className={className} />
        <span className="checkbox__input"></span>
        {children}
      </label>
      {error && <FormError message={error} />}
    </div>
  )
}
